/**
 * App.js Layout Start Here
 */
import React from "react";
import { Error } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";

function InputKendoRct({
  validityStyles,
  name,
  value,
  onChange,
  label,
  error,
  minLength,
  required,
  maxLength,
  type,
  disabled,
  focusout,
  placeholder,
  pattern,
  className,
}) {
  return (
    <div>
      <Input
        validityStyles={validityStyles}
        name={name}
        value={value}
        onChange={onChange}
        label={label}
        maxLength={maxLength}
        type={type}
        disabled={disabled}
        minLength={minLength}
        focusout={focusout}
        required={required}
        placeholder={placeholder}
        pattern={pattern}
        className={className}
        style={{ width: "100%" }}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
}
export default InputKendoRct;
